<script setup>
import { ref } from 'vue';
import GeneralSettings from './GeneralSettings.global.vue';
import CountrySpecificConfig from './CountrySpecificConfig.global.vue';
import USSDSetting from './USSDSetting.global.vue';
import PaymentProvidersSetting from './PaymentProvidersSetting.global.vue';
import ManualOperationsSetting from './ManualOperationsSetting.global.vue';
import LimitsSettings from './LimitsSettings.global.vue';

const activeTab = ref('general');

const tabs = [
  { id: 'general', label: 'Général', icon: '⚙️' },
  { id: 'countryConfig', label: 'Config par pays', icon: '🌍' },
  { id: 'paymentProviders', label: 'Aggrégateurs', icon: '💳' },
  { id: 'manualOperations', label: 'Configs USSDs', icon: '📋' },
  { id: 'limits', label: 'Limites', icon: '💰' }
];
</script>

<template>
  <PageLayout>
    <template #headerTitle>Paramètres de l'application</template>

    <div class="space-y-6">
      <!-- TABS -->
      <div class="flex flex-wrap gap-2 border-b border-gray-200 pb-2">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          @click="activeTab = tab.id"
          :class="[
            'px-6 py-3 rounded-xl font-medium transition-all flex items-center gap-2',
            activeTab === tab.id
              ? 'bg-primary text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          ]"
        >
          <span>{{ tab.icon }}</span>
          <span>{{ tab.label }}</span>
        </button>
      </div>

      <!-- TAB CONTENT -->
      <div class="mt-6">
        <GeneralSettings v-if="activeTab === 'general'" />
        <CountrySpecificConfig v-else-if="activeTab === 'countryConfig'" />
        <PaymentProvidersSetting v-else-if="activeTab === 'paymentProviders'" />
        <ManualOperationsSetting v-else-if="activeTab === 'manualOperations'" />
        <LimitsSettings v-else-if="activeTab === 'limits'" />
        <USSDSetting v-else-if="activeTab === 'ussd'" />
      </div>
    </div>
  </PageLayout>
</template>

